import React from 'react';
import { Input } from '@/components/ui/input';
import { Slider } from '@/components/ui/slider';
import { cn } from '@/lib/utils';
export const ColorSwatch = ({ color, label, onChange }) => (<div className="flex items-center gap-2.5">
        <div className="relative w-8 h-8 rounded-md border border-border overflow-hidden shrink-0 cursor-pointer" style={{ background: color }}>
            <input type="color" value={color} onChange={(e) => onChange(e.target.value)} className="absolute inset-0 opacity-0 w-full h-full cursor-pointer" aria-label={`Pick ${label} color`}/>
        </div>
        <span className="text-xs text-muted-foreground flex-1">{label}</span>
        <Input value={color} onChange={(e) => {
        if (/^#[0-9a-fA-F]{0,6}$/.test(e.target.value))
            onChange(e.target.value);
    }} className="h-7 text-xs font-mono w-24" maxLength={7} aria-label={`${label} hex value`}/>
    </div>);
export function SliderRow({ label, value, min, max, step, onChange, display }) {
    return (<div className="flex items-center gap-3">
            <span className="text-xs text-muted-foreground w-24 shrink-0">{label}</span>
            <Slider value={[value]} min={min} max={max} step={step} onValueChange={([v]) => onChange(v)} className="flex-1" aria-label={label}/>
            <span className="text-xs font-mono text-muted-foreground w-10 text-right">{display ?? value}</span>
        </div>);
}
ColorSwatch.displayName = 'ColorSwatch';
export const SectionTitle = ({ children }) => (<h3 className="text-[11px] font-bold text-muted-foreground uppercase tracking-widest mb-2.5">{children}</h3>);
SectionTitle.displayName = 'SectionTitle';
export const StyleGrid = ({ items, selected, onSelect, renderPreview }) => (<div className="grid grid-cols-5 gap-1.5">
        {items.map((item) => (<button key={item.id} onClick={() => onSelect(item.id)} aria-pressed={selected === item.id} className={cn('flex flex-col items-center gap-1 p-1.5 rounded-lg border transition-all', selected === item.id
            ? 'border-primary bg-primary/10 dark:bg-primary/20'
            : 'border-border hover:border-primary bg-white dark:bg-muted')}>
                <div className="w-10 h-10 rounded overflow-hidden flex items-center justify-center bg-[#f5f4f2] dark:bg-muted">
                    {renderPreview(item.id)}
                </div>
                <span className={cn('text-[9px] font-semibold uppercase tracking-wide leading-tight text-center', selected === item.id ? 'text-primary' : 'text-muted-foreground')}>
                    {item.label}
                </span>
            </button>))}
    </div>);
StyleGrid.displayName = 'StyleGrid';
